export function capitalize(value: string | undefined) {
  if (!value) {
    return undefined
  }

  return value[0].toLocaleUpperCase() + value.slice(1)
}

export default capitalize
